import { Component, ViewChild, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FormControl } from '@angular/forms';
import { MatChip, MatChipListbox } from '@angular/material/chips';

@Component({
  template: `
    <mat-chip-listbox
      #chipList
      [formControl]="formControl"
      [formlyAttributes]="field"
      [multiple]="to.multiple"
      [class]="to.className"
      [selectable]="to.selectable">
      <mat-chip-option
        #chip
        *ngFor="let option of to.options | formlySelectOptions: field | async; let i = index" 
        [disabled]="!to.selectable || option.disabled" 
        color="accent" 
        [value]="option.value" 
        [selected]="isSelected(option.value)" 
        (click)="toggleSelection(chip)"
        (blur)="onBlur()"
      >
        {{ option.label }}
      </mat-chip-option>
    </mat-chip-listbox>
  `,
  styleUrls: ['./chips.type.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})

export class ChipsType extends FieldType<any> implements OnInit {
  
  override get formControl(): FormControl {
    return this.field.formControl as FormControl;
  }
  
  @ViewChild(MatChipListbox)
  chipList!: MatChipListbox;

  override defaultOptions = {
    templateOptions: {
      hideFieldUnderline : true,
      appearance :'outline',
      selectable : true,
      multiple : false,
      defaultValue : []
    },
  };

  ngOnInit() {
    if (!this.formControl.value) {
      this.formControl.setValue([]);
    }
    
    if (this.to.defaultValue && this.to.defaultValue.length > 0) {
      this.formControl.setValue(
        this.to.multiple ? this.to.defaultValue : [this.to.defaultValue[0]]
      );
    }
  }

  toggleSelection(chip: MatChip) {
    if (this.to.selectable && !chip.disabled) {
      chip.focus();
      if (chip.highlighted) {
        this._add(chip.value);
      } else {
        this._remove(chip.value);
      }
    }
  }

  private _add(value: any) {
    const currentValue = Array.isArray(this.formControl.value) ? this.formControl.value : [];
    // 複数選択可能の場合
    if (this.to.multiple) {
      this.formControl.setValue([
        ...this.formControl.value,
        value,
      ]);
    } else {
      this.formControl.setValue([value]);
    }
  }

  private _remove(value: any) {
    let i = this.formControl.value.indexOf(value);
    if (i > -1) {
      // 複数選択可能の場合
      if (this.to.multiple) {
        this.formControl.setValue([
          ...this.formControl.value.slice(0, i),
          ...this.formControl.value.slice(i + 1, this.formControl.value.length)
        ]);
      } else {
        this.formControl.setValue([]);
      }
    }
  }

  isSelected(value: any) {
    return this.formControl.value.indexOf(value) > -1
  }

  onBlur() {
    this.formControl.markAsTouched();
    this.field.focus = false;
  }
  
}
